import { render } from "./lane.vue?vue&type=template&id=b95fe7c6&scoped=true"
import script from "./lane.vue?vue&type=script&lang=js"
export * from "./lane.vue?vue&type=script&lang=js"

import "./lane.vue?vue&type=style&index=0&id=b95fe7c6&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95fe7c6"]])

export default __exports__